/*----------------------------------
- DOMAINS RAIL CHOICE
----------------------------------*/

/**
 * A choice filter's options (TLD, Status, Word type) as the mock draws them (`dm-opt`): a check, the label and a
 * text-free share bar (`wp-sk`). No count anywhere: nothing on this surface re-queries, so a count would describe a
 * search the page cannot run. Each option is a wall naming the query it would set.
 *
 * Every option of the catalog is drawn: the unlocked choice filters hold five to seven (the shipped rail's "Show all"
 * past eight opened a picker that only the locked filters' lists would need).
 */

/*----------------------------------
- DEPENDANCES
----------------------------------*/

import type { RadarOption } from '@uniquedomains/components/radar/rules/types';

/*----------------------------------
- TYPES
----------------------------------*/

type DomainsRailChoiceProps = {
    options: readonly RadarOption[];
    selected: ReadonlySet<string>;
    onPick: (value: string) => void;
};

/*----------------------------------
- COMPONENT
----------------------------------*/

const DomainsRailChoice = ({ options, selected, onPick }: DomainsRailChoiceProps) => (
    <>
        {options.map((option) => {
            const value = String(option.value);
            return (
                <button
                    key={value}
                    type="button"
                    class="dm-opt"
                    // Not `aria-pressed`: the option opens a wall, it toggles nothing (review m-17). `data-selected` keeps
                    // the checked look for a rule the search on screen already carries.
                    data-selected={selected.has(value) ? 'true' : undefined}
                    data-radar-rule-choice-option={value}
                    onClick={() => onPick(value)}
                >
                    <span class="dm-check" aria-hidden="true" />
                    <span>{option.label}</span>
                    <span aria-hidden="true"><span class="wp-sk" style={{ '--w': '100%' }} /></span>
                </button>
            );
        })}
    </>
);

export default DomainsRailChoice;
